import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { createImageUrlBuilder } from '@sanity/image-url';
import { client } from '@/sanity/client';
const builder = createImageUrlBuilder(client);
function urlFor(source: any) {
  return builder.image(source);
}
interface AccoladeItem {
  type: 'number' | 'numberWithPrefix' | 'image';
  value?: string;
  prefix?: string;
  image?: any;
  label?: string;
}
interface AccoladesProps {
  title?: string;
  seoDescription?: string;
  backgroundImage?: any;
  items?: AccoladeItem[];
}
export default function Accolades(t0) {
  const $ = _c(22);
  const {
    title: t1,
    seoDescription,
    backgroundImage,
    items: t2
  } = t0;
  const title = t1 === undefined ? "Our Accolades" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  if (!items || items.length === 0) {
    return null;
  }
  let t4;
  if ($[2] !== backgroundImage) {
    t4 = backgroundImage?.asset?.url ? urlFor(backgroundImage).width(1920).url() : undefined;
    $[2] = backgroundImage;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const backgroundUrl = t4;
  const t5 = backgroundUrl ? `url(${backgroundUrl})` : undefined;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      backgroundImage: t5,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute inset-0 bg-[#f8f7f5]/40 dark:bg-[#141414]/60" />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== title) {
    t8 = <h2 className="font-serif text-[var(--color-sothebys-blue)] dark:text-white text-center mb-4">{title}</h2>;
    $[7] = title;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = seoDescription || "Recognized among the finest in luxury real estate, Klug Properties and Aspen Snowmass Sotheby\u2019s International Realty consistently set the standard for excellence in the Roaring Fork Valley.";
  let t10;
  if ($[9] !== t9) {
    t10 = <p className="text-[var(--color-sothebys-blue)]/70 dark:text-white/60 text-sm font-light max-w-2xl mx-auto text-center mb-8 leading-relaxed">{t9}</p>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== items) {
    t11 = items.map(_temp);
    $[11] = items;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = <div className="bg-white/80 dark:bg-[#1a1a1a]/80 py-12 px-6 md:px-8"><div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-12 gap-x-8">{t11}</div></div>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t12 || $[17] !== t8) {
    t13 = <div className="relative py-12 md:py-16"><div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">{t8}{t10}{t12}</div></div>;
    $[15] = t10;
    $[16] = t12;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t6) {
    t14 = <section className="relative w-full overflow-hidden" style={t6}>{t7}{t13}</section>;
    $[19] = t13;
    $[20] = t6;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
}
function _temp(item, index) {
  return <div key={index} className={`flex flex-col items-center text-center ${index % 3 === 1 ? "lg:border-l lg:border-r lg:border-[#c9a962] dark:lg:border-gray-700" : ""}`}>{item.type === "image" && item.image ? <div className="h-24 md:h-28 flex justify-center items-center mb-4"><div className="relative h-20 w-20 md:h-24 md:w-24"><Image src={urlFor(item.image).width(200).url()} alt={item.label || "Accolade"} fill={true} className="object-contain" /></div></div> : <div className="text-[#1a1a1a] dark:text-white font-serif font-light mb-4" style={{
      fontSize: "clamp(3rem, 8vw, 6rem)",
      letterSpacing: "-0.02em",
      lineHeight: "1"
    }}>{item.type === "numberWithPrefix" && item.prefix && <span className="text-[var(--color-gold)]" style={{
        fontSize: "clamp(2rem, 5vw, 4rem)"
      }}>{item.prefix}</span>}{item.value}</div>}<div className="w-8 h-px bg-[var(--color-gold)] mb-4" />{item.label && <span className="text-[#6a6a6a] dark:text-gray-400 text-sm font-light tracking-wide leading-relaxed">{item.label}</span>}</div>;
}